import { Box, Button, Center, Fieldset, Group, NumberInput, Title } from "@mantine/core";
import { FC, useState } from "react";
import ReactSelect from "react-select";

interface InitialValues {
  minExpectedCloseDate?: string;
  maxExpectedCloseDate?: string;
  minProjectedTotal?: number | string;
  maxProjectedTotal?: number | string;
  span?: number;
}

const EXPECTED_SPANS = new Map([
  ["0", "All"],
  ["30", "30 Days"],
  ["60", "60 Days"],
  ["90", "90 Days"],
])

interface Props {
  initialValues: InitialValues;
  onClose: (v: InitialValues) => void;
  onClear: (v: InitialValues) => void;
}

const AdvancedFilterForm: FC<Props> = ({ initialValues, onClose, onClear }) => {
  const [s, setS] = useState(initialValues);
  return (
    <Box>
      <Title order={3} fw="normal">Advanced Filters</Title>      
      <Fieldset pos="relative" legend="Revenue Start Date" my="xl">        
        <ReactSelect
          value={{
            value: s?.span?.toString(),
            label: EXPECTED_SPANS.get(s?.span?.toString() + "")
          }}
          options={[...EXPECTED_SPANS.entries()].map(([k, v]) => ({
            label: v,
            value: k,
          }))}
          onChange={(v) => {
            if (v?.value) {
              setS({...s, span: parseInt(v?.value)})
            }
          }}
        />
      </Fieldset>
      <Fieldset pos="relative" legend="Projected Revenue Total">
        <Group gap={50} justify="center" ml={-30}>
          <NumberInput
            placeholder="min"
            w="100px"
            hideControls
            value={s.minProjectedTotal}
            onChange={(e) => setS({ ...s, minProjectedTotal: e })}
            prefix="$ "        
            thousandSeparator=","
            decimalSeparator="."
            inputMode="decimal"
            styles={{
              input: {
                fontSize: 16,        // ← stops iOS zoom
                paddingTop: 0,
                paddingBottom: 0,
              },
            }}
          />
          <NumberInput
            placeholder="max"
            w={100}
            hideControls
            value={s.maxProjectedTotal}
            prefix="$ "        
            thousandSeparator=","
            decimalSeparator="."
            inputMode="decimal"
            onChange={(e) => setS({ ...s, maxProjectedTotal: e })}
            styles={{
              input: {
                fontSize: 16,        // ← stops iOS zoom
                paddingTop: 0,
                paddingBottom: 0,
              },
            }}
          />
        </Group>
      </Fieldset>
      <Center mt="xl">
        <Group>
          <Button 
            bg="#FF9D00"
            c="white"
            onClick={() => {
              const clearedValues = {
                minExpectedCloseDate: "",
                maxExpectedCloseDate: "",
                minProjectedTotal: "",
                maxProjectedTotal: "",
                span: 0,
              }
              setS(clearedValues);
              onClear(clearedValues);
            }}>
            Clear
          </Button>
          <Button 
            bg="#4F7D9C"
            c="white"
            onClick={() => {
              onClose(s);
            }}>Apply Filter
          </Button>
        </Group>
      </Center>
    </Box>
  );
};

export default AdvancedFilterForm